
import { Component, HostListener, Inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { DataService } from '../../Services/data.service';
import { DialogService } from '../../Services/dialog.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { Comments, CommentsComponent } from '../comments/comments.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FileDetails, FilesComponent } from '../files/files.component';
import { MatMenuModule } from '@angular/material/menu';
import { OptionsDialogComponent } from '../dialogs/options-dialog/options-dialog.component';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClient, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { MyBoolean, OrderDetailsNew } from '../../models/order.models';
import { FilesDialogComponent } from '../files-dialog/files-dialog.component';
import { finalize } from 'rxjs/operators';
import { FeedbackDialogComponent } from '../task-list/feedback-dialog/feedback-dialog.component';
import { ChangeDetectorRef, inject } from '@angular/core';
import { UploadState, FileProgress, Task } from '../../models/task.models';

@Component({
  selector: 'app-order-reiew-model',
  standalone: true,
  imports: [MatPaginatorModule, CommonModule, MatSelectModule, MatCardModule, FormsModule, MatFormFieldModule, MatInputModule, DatePipe, MatCheckboxModule, MatIconModule, MatButtonModule, MatBadgeModule, MatMenuModule, MatTooltipModule, MatDialogModule],
  templateUrl: './order-reiew-model.component.html',
  styleUrl: './order-reiew-model.component.css'
})
export class OrderReiewModelComponent {
    @Input() fileDetailsImagesContent!: string[];
    @Input() orderDetailsNew!: OrderDetailsNew;
    private cdr = inject(ChangeDetectorRef); // Inject this


  feedbackId: string = '';
  showModelNow: boolean = false;
  comments: Comments[] = [];
    rating = 0;
  hoveredRating = 0;
  stars = [1, 2, 3, 4, 5];
    feedbackTextFinal: string = '';
  cancelReason: string = '';
  taskStatus: string = '';
   inProgressCount: any;
   feedbackText = '';
   isReviewModalOpen = false;


timeLeft: any;
  status: string = '';
  taskData: Task[] = [];
  filteredTaskData: Task[] = [];
  selectedTaskIds: number[] = [];
  procSummaryByTask: Map<number, string> = new Map();
  doctorList: any[] = [];
  designerList: any[] = [];

  fileCountsNew: any = {}
  fileCountsDesign: any = {}
  fileCountsScan: any = {}
  fileCountsTotal: any = {}
  
  stepNumber: Number = 1;
  fileDetailsScan: FileDetails[] = [];
  downloadProgressId: { id: number; situation: number }[] = [];
   fileDetailsDesign: FileDetails[] = [];
     fileDetails: FileDetails[] = [];
       fileDetailsImages: FileDetails[] = [];
       // fileDetailsImagesContent: string[] = [];
       fileDetailsOrderForm: FileDetails[] = [];
       fileDetailsVisual: FileDetails[] = [];
       fileDetailsCorrectedDesign: FileDetails[] = [];
       fileDetailsCorrected3dVisualisation: FileDetails[] = [];
         taskDetails: any;

   taskId: number = 0;
   downloadProgress: Number = 0;
  constructor(private http: HttpClient, public dataService: DataService, private dialogService: DialogService, private route: ActivatedRoute, private dialog: MatDialog, private location: Location, private router: Router) { }


  
  changeStep(stepNumber: Number) {
    this.stepNumber = stepNumber
  }

private orderModalInitialized = false;

  closeModal(showModel: boolean) {
    this.showModelNow = false;
  this.orderModalInitialized = false;

  }
  checkCondition(id: number, situation: number): boolean {
    return this.downloadProgressId.some(item => item.id === id && item.situation === situation);
  }
  
  downloadFile(fileId: number, fileName: string) {
    this.dataService.updateProgressBarSubject(true);
    this.downloadProgress = 1
    let restData = this.downloadProgressId.filter(data => data.id !== fileId)
    restData.push({ "id": fileId, "situation": 1 })
    this.downloadProgressId = restData


    this.dataService.get('/tasks/' + this.taskId + '/files/' + fileId, { responseType: 'blob' }).subscribe({
      next: (response) => {
        const blob = new Blob([response], { type: 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        this.dataService.updateProgressBarSubject(false);

        this.downloadProgress = 2

        let restData = this.downloadProgressId.filter(data => data.id !== fileId)
        restData.push({ "id": fileId, "situation": 2 })
        this.downloadProgressId = restData



      },
      error: (err) => {
        this.downloadProgress = 3
        let restData = this.downloadProgressId.filter(data => data.id !== fileId)
        restData.push({ "id": fileId, "situation": 3 })
        this.downloadProgressId = restData

        this.dialogService.handleError(err, 'Failed to download the file, Please try again.');
      }
    });
  }

    async populateImagesContent(fileId: number) {
    try {
      const response = await firstValueFrom(this.dataService.get('/tasks/' + this.taskId + '/files/' + fileId, { responseType: 'blob' }));
      this.fileDetailsImagesContent.push(URL.createObjectURL(new Blob([response], { type: 'application/octet-stream' })));
    } catch (err) {
      this.dialogService.handleError(err, 'Failed to get File Contents, Please try again.');
    }
  }
  getComments(taskId: Number) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/' + taskId + '/comments').subscribe({
      next: (response) => {
        this.comments = response;
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Comments for this Task, Please try again.');
      }
    });
  }

getFileDetails(taskId: Number) {
    this.taskId = taskId as number; // Set the taskId property
    this.dataService.updateProgressBarSubject(true);
    this.dataService.getDataAsList('/tasks/' + taskId + '/files').subscribe({
      next: (response: FileDetails[]) => {
        this.showModelNow = true; 
        this.cdr.detectChanges();
        this.fileDetails = response;

        this.fileDetailsScan = [];
        this.fileDetailsDesign = [];
        this.fileDetailsVisual = [];
        this.fileDetailsImages = [];
        this.fileDetailsImagesContent = [];
        this.fileDetailsCorrectedDesign = [];
        this.fileDetailsCorrected3dVisualisation = [];
        response.forEach(file => {
          if (file.fileType == 'scan') {
            this.fileDetailsScan.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'design') {
            this.fileDetailsDesign.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'visual') {
            this.fileDetailsVisual.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'images') {
            this.fileDetailsImages.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
            this.populateImagesContent(file.fileId);
          } else if (file.fileType == 'correcteddesign') {
            this.fileDetailsCorrectedDesign.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          } else if (file.fileType == 'correctedvisual') {
            this.fileDetailsCorrected3dVisualisation.push(file);
            this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })
          }
          
          // else {
          //   this.fileDetailsDesign.push(file);
          //   this.downloadProgressId.push({ "id": file.fileId, "situation": 0 })

          // }
        });

        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Files for this Task, Please try again.');
      }
    });

    this.dataService.get('/tasks/' + taskId).subscribe({
      next: (response) => {
        this.taskDetails = response;
        this.orderDetailsNew = JSON.parse(response.jsonData);
         // 👇 Persisted state from backend
  
        this.getComments(taskId);
        // this.getFileCountsFromBackend();
        // this.getCommentsCountsFromBackend();
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to get Task Details, Please try again.');
      }
    });
  }
    progress: Record<string, FileProgress> = {};
     showFeedbackMessage: boolean = false;
feedbackMessage: string = '';
showButtons: boolean = true;  
isRequestCorrection=false;
ShowRequestFeedback: boolean = false;
feedbackMessageRequest: string = '';

  // File Upload Functionality Starts Here
  removeProgress(name: string) {
    delete this.progress[name]; 
  }
    requestCorrection(taskId: any) {

      if (this.isRequestCorrection) return; 
  this.isRequestCorrection = true;
    //if (this.feedbackText.length === 0) {
   // }
      this.submitFeedback(taskId);
   // }

  }
      

   submitFeedback(taskId: any) {
    this.dataService.put('/tasks/' + taskId + '/feedback', { comment: this.feedbackText,feedbackId:this.feedbackId }).subscribe({
      next: (response) => {
        this.dataService.updateProgressBarSubject(false);
        // this.dialogService.openMessageDialog('Info', 'Saved the Feedback successfully.').subscribe(response => {
        // this.closeModal(false);
        if(this.isRequestCorrection){
            this.feedbackMessageRequest ='Feedback Saved successfully!';

        this.ShowRequestFeedback = true;

        }else{
       this.feedbackMessage =
          this.feedbackId === '1'
            ? 'Task Cancelled successfully'
            : 'Feedback Saved successfully!';

        this.showFeedbackMessage = true;

        this.showReviewOverlay = false;
        this.showButtons = false;}
    
        //this.closeModal(false);
      },
      error: (err) => {
       // this.dialogService.handleError(err, 'Failed to save Feedback, Please try again.');
        //this.closeModal(false);
         this.dataService.updateProgressBarSubject(false);

       
        this.feedbackMessage = 'Failed to save feedback, please try again.';
        this.showFeedbackMessage = true;          
      
      }
    });

  }
  removeFileByName(fileName: string) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService.delete('/tasks/' + this.taskId + '/files?file-name=' + fileName.replace(/[^a-zA-Z0-9.]/g, '_')).subscribe({
      next: (response) => {
        var index = this.fileDetailsScan.findIndex((file) => file.fileName === fileName);
        if (index > -1) {
          this.fileDetailsScan.splice(index, 1);
        }
        this.dataService.updateProgressBarSubject(false);
      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to Remove File, Please try again.');
      }
    });
  }

  rate(value: number) {
    this.rating = value;
  }

  hover(value: number) {
    this.hoveredRating = value;
  }
  cancelOrder() {
    this.dataService.updateProgressBarSubject(true);
    var commentToSave = this.feedbackId == '1' ? this.cancelReason : this.feedbackTextFinal;
    
    this.dataService.put('/tasks/' + this.taskId + '/feedback', { feedbackId: this.feedbackId, comment: commentToSave, rating: this.rating }).subscribe({
      next: (response) => {
        this.taskStatus = this.feedbackId == '2' ? 'IC' : 'CO';
        var msg = this.feedbackId == '1' ? 'Task Cancelled successfully' : 'Saved the Feedback successfully.'
        this.dialogService.openMessageDialog('Info', msg).subscribe(response => {
          // this.router.navigate(['/task-list/delivered']);
          //this.getTasks();
        }
        );

        this.stepNumber = 1
        this.showModelNow = false

        if(this.feedbackId == '1'){
          this.dataService.post('/common/notifications/' + this.taskId + '/CANCELED', {}).subscribe({})
        }
        
        this.dataService.updateProgressBarSubject(false);

      },
      error: (err) => {
        this.dialogService.handleError(err, 'Failed to save Feedback, Please try again.');
      }
    });
  }
   addFileDetails(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    if (!files.length) {
      this.dialogService.openMessageDialog('Error', 'Select a file to Upload.');
      return;
    }
    //files.forEach(f => this.uploadWithProgress(f));
    input.value = '';
  }
  showReviewOverlay = false;

onApprove() {
    this.feedbackId = '3';
    this.showReviewOverlay = true; 
    this.showModelNow=true;
  }


isApproved(): boolean {
  return String(this.feedbackId) === '3';
}

hasCorrected3d(): boolean {
  const hasData = !!(
    this.fileDetailsCorrected3dVisualisation &&
    this.fileDetailsCorrected3dVisualisation.length > 0
  );


  return hasData;
}

loadTask(task: any) {
  this.feedbackId = task.feedbackId; 
}



changeStepToRequestCorrection() {
  this.stepNumber = 3;
  this.feedbackId = '2';
  this.changeStep(3);
}

setStepAndFeedback(step: number, feedback: string) {
  this.stepNumber = step;
  this.feedbackId = feedback;
}



}
